import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import LittleLensLogo from './LittleLensLogo';

interface LoadingSpinnerProps {
  message?: string;
  size?: number;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ 
  message, 
  size = 40 
}) => {
  const { t } = useTranslation('components', { keyPrefix: 'loadingSpinner' });

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'transparent',
        zIndex: 9999,
        gap: 2.5,
        margin: 0,
        padding: 0,
        boxSizing: 'border-box',
      }}
    >
      <LittleLensLogo maxWidth={70} maxHeight={60} />
      <CircularProgress 
        size={size} 
        thickness={3.5}
        sx={{
          color: 'primary.main',
        }}
      />
      <Typography 
        variant="body2" 
        color="text.secondary"
        sx={{ 
          fontWeight: 600,
          letterSpacing: 0.3,
          textAlign: 'center',
        }}
      >
        {message ?? t('loading')}
      </Typography>
    </Box>
  );
};

export default LoadingSpinner;
